import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore';
import FJVerticalScroller from '../FJScroller/FJVerticalScroller';
import React, { Fragment, Component } from 'react';
import styles from './FJSearchHistory.module.less';
import SearchDeleteIcon from '../../../assets/svg/search/search-delete.svg?react';
import FJKeyword from './FJKeyword';
import FJTransverse from './FJTransverse';

class FJSearchHistory extends Component {
    componentDidMount() {
        this._bindEvent();
    }

    componentWillUnmount() {
        this._unBindEvent();
    }

    _bindEvent = () => {
        document.addEventListener('keydown', this._keyDown);
    };

    _unBindEvent = () => {
        document.removeEventListener('keydown', this._keyDown);
    };

    _keyDown = e => {
        // Esc 按下
        if (e.keyCode === 27) {
            this.props.hide();
        }
    };

    render() {
        const { keywords = [], onSearch, onClear, active, style, populars = [], isElement, maxHeight } = this.props;
        return (
            <div
                onMouseDown={e => {
                    e.preventDefault();
                }}
                style={{
                    ...style,
                    top: style.top + 4,
                }}
                ref={ele => (this._dropEle = ele)}
                className={classNames(styles.box, active ? styles.active : null)}
                data-auto-id='APP_Search_Box'
            >
                <FJVerticalScroller
                    style={{
                        maxHeight: maxHeight - 50 + 'px',
                    }}
                >
                    {keywords.length !== 0 ? (
                        <Fragment>
                            <div ref={ele => (this._historyEle = ele)}>
                                <div className={styles.info} style={{ marginBottom: '2px' }}>
                                    <span className={styles.title}>{FJLocalStore._('recent-searches')}</span>

                                    <div onClick={onClear} className={styles.delete}>
                                        <SearchDeleteIcon />
                                    </div>
                                </div>
                                <div
                                    className={styles.list}
                                    style={{
                                        padding: populars.length === 0 ? '0 14px' : '0 14px 8px 14px',
                                    }}
                                >
                                    {keywords.map(keyword => (
                                        <FJKeyword
                                            keyword={keyword}
                                            key={keyword}
                                            onClick={() => {
                                                onSearch(keyword);
                                            }}
                                            active={active}
                                        />
                                    ))}
                                </div>
                            </div>
                        </Fragment>
                    ) : null}
                    {populars.length !== 0 ? (
                        <>
                            <div>
                                <div className={styles.info}>
                                    <span className={styles.title}>{FJLocalStore._('suggested-searches')}</span>
                                </div>
                                <div ref={ele => (this._popularEle = ele)}>
                                    <div className={styles.list}>
                                        {populars.map((popular, index) => (
                                            <FJTransverse
                                                keyword={popular}
                                                key={popular + index}
                                                onClick={() => {
                                                    window.is_popular = true;
                                                    onSearch(popular, true);
                                                }}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : null}
                </FJVerticalScroller>
            </div>
        );
    }
}

export default FJSearchHistory;
